import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import GlobalContext from "contexts/GlobalContext";
import { useTranslator } from "../../../common/Translation/Translator";
import Page from "pages/Page";
import { ValueAppWidget } from "@sia/style-guide";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";

const ValueAppWidgetPage = () => {
  const { id } = useParams();
  const [entry, setEntry] = useState(null);
  const { language } = useContext(GlobalContext);
  const translate = useTranslator();
  const apiKey = process.env.REACT_APP_VALUE_APP_KEY;

  // Meta configuration for the widget (permissions, roles, etc.)
  const default_meta = {
    canEdit: true,
    canView: true,
    roles: ["ARCHITECT"],
    isGp: false,
    parts: ["ARCHITECT"],
    title: "Demo Project 101",
    userId: "de000000-0000-0000-0000-000000000000",
  };

  const fetchProjectData = () => {
    if (!id) return;
    pgAdapter.getValueAppProjectList(
      (response) => {
        const { data } = response;
        // Find the project with the matching ID.
        const project = data.find((p) => p.project_id === id);
        if (!project) {
          console.warn("No project found for ID:", id);
          return;
        }
        setEntry(project.data);
      },
      (error) => {
        console.error("Error retrieving project:", error);
      }
    );
  };

  useEffect(() => {
    fetchProjectData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSaveProject = (savedData) => {
    console.log("Received updated JSON from widget:", savedData);
    const normalizedData = Array.isArray(savedData) ? savedData[0] : savedData;
    console.log("Normalized Data:", normalizedData);

    pgAdapter.updateValueAppProject(
      {
        data: normalizedData,
        project_id: id,
      },
      (response) => {
        console.log("Project updated successfully.");
        fetchProjectData();
      },
      (error) => {
        console.error("Error updating project:", error);
      }
    );
  };

  const getLocale = (shortLocale) => {
    const locales = {
      de: "de_CH",
      en: "en_US",
      fr: "fr_CH",
      it: "it_CH",
    };
    return locales[shortLocale];
  };

  return (
    language && (
      <Page title={translate("header.app-switcher.value-app.name")}>
        <ValueAppWidget apiKey={apiKey} meta={default_meta} entry={entry || {}} lang={getLocale(language)} onSaveCallback={handleSaveProject} />
      </Page>
    )
  );
};

export default ValueAppWidgetPage;
